<div class="vtr-ui-circle-radio col-aut0 px-0">
	<div class="checkbox">
		<input class="checkbox-custom"
			id="{{radioId}}"
			attr.aria-label="{{radioId}}"
			name="{{group}}"
			type="radio"
			[value]="value"
			[checked]="checked"
			[disabled]="disabled"
			#radio
			(change)="onChange($event)">
		<label for="{{radioId}}"
			class="checkbox-custom-label" id="{{radioId}}" attr.aria-label="{{radioId}}">
			<div *ngIf="!hideIcon"
				[ngClass]="'icomoon icomoon-'+getIconName(value)"></div>
		</label>
		<div [ngClass]="['title','text-center',theme==='white'?'text-primary':'text-white']"
			id="{{textId}}-{{value}}-label" attr.aria-label="{{textId}}-{{value}}-label">{{label|uppercase}}</div>
	</div>
</div>
